import React, { Suspense } from "react";
import Promotions from "~/modules/promotions/promotions";
import styles from "~/route-containers/partner/partner.module.css";
import offerStyles from "./offer-container.module.css";
import { InternalView } from "~/components/internal-view";
import { useTranslation } from "react-i18next";
import { Await, useLoaderData } from "@remix-run/react";
import EmptyState from "~/components/empty-states/empty-state/empty-state";

const OfferContainer = () => {
  const { t } = useTranslation();
  const { promotion } = useLoaderData();

  return (
    <InternalView
      copy={t("offers_internal_page.offer")}
      cover={""}
      breadcrumbs={[{ text: t("offers_internal_page.offer") }]}>

      <Suspense fallback={<></>}>
        <Await
          resolve={promotion}
          errorElement={<p>Error loading package location!</p>}>

          {(p) =>
          p ?
          <div
            className={`${styles.wrapperContainer} ${offerStyles.offerContainer}`}>

                <Promotions promotions={[p]} />
              </div> :

          <EmptyState searchProduct={true} />}


        </Await>
      </Suspense>
    </InternalView>);

};

export default OfferContainer;